export default function initHomeTransition() {
    const home = document.querySelector('#home');
    const menu = document.querySelector('#menu');
    const main = document.querySelector('#main');
    const background = document.querySelector('#background');
    const animations = document.querySelectorAll('#animation');
    const crossLinks = document.querySelector('#crosslinks');
    const bitlLogo = document.querySelector('#bitl-logo');
    const bigLogo = document.querySelector('#big-logo');
    const rabobank = document.querySelector('#rabobank');

    function removeDurations() {
        background.classList.remove('duration-3000');
        menu.classList.remove('lg:duration-3000');
        main.classList.remove('duration-3000');
        crossLinks.classList.remove('duration-3000');
        bitlLogo.classList.remove('duration-3000');
        bigLogo.classList.remove('duration-3000');
        rabobank.classList.remove('duration-3000');

        let i = 0;

        while (i < animations.length) {
            const animation = animations[i];
            animation.classList.remove('duration-3000');
            i += 1;
        }
    }

    function transformElements() {
        background.classList.add('lg:h-112');
        menu.classList.remove('lg:-translate-x-0');
        menu.classList.add('lg:w-128');
        menu.classList.remove('lg:w-1/3screen');
        menu.classList.remove('lg:w-1/3screen');
        menu.classList.add('lg:-translate-x-2/4');
        main.classList.remove('lg:ml-1/3screen');
        main.classList.add('lg:ml-64');
        crossLinks.classList.remove('lg:translate-x-full');
        bitlLogo.classList.remove('opacity-0');
        bigLogo.classList.add('opacity-0');
        rabobank.classList.add('opacity-0');
        setTimeout(() => { menu.classList.add('duration-500'); }, 1);

        let i = 0;

        while (i < animations.length) {
            const animation = animations[i];
            animation.classList.remove('lg:w-12vw');
            i += 1;
        }
    }

    function transformElementsNotHome() {
        menu.classList.remove('lg:duration-3000');
        main.classList.remove('duration-3000');
        bitlLogo.classList.remove('duration-3000');
        menu.classList.remove('lg:-translate-x-0');
        menu.classList.add('lg:w-128');
        menu.classList.remove('lg:w-1/3screen');
        menu.classList.remove('lg:w-1/3screen');
        menu.classList.add('lg:-translate-x-2/4');
        main.classList.remove('lg:ml-1/3screen');
        main.classList.add('lg:ml-64');
        main.classList.remove('lg:ml-1/3screen');
        main.classList.add('lg:ml-64');
        bitlLogo.classList.remove('opacity-0');
        setTimeout(() => { menu.classList.add('duration-500'); }, 1);
    }

    let scrolled = false;

    if (home == null) {
        scrolled = true;
        setTimeout(() => { transformElementsNotHome(); }, 1);
    } else if (window.scrollY > 10) {
        scrolled = true;
        removeDurations();

        setTimeout(() => { transformElements(); }, 1);
    }

    if (scrolled === false) {
        window.onscroll = function (e) {
            scrolled = true;
            transformElements();
        };
        // });
    }
}
